import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'CLIENT_FAV',
  title: 'Comment ajouter mon client aux favoris ?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Rendez-vous sur l’onglet Clients'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CLIENT_FAV/FR_CLIENT_FAV_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Sélectionnez le client de votre choix'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Cliquer sur l’étoile en haut à droite pour l’ajouter ou le retirer de vos favoris'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CLIENT_FAV/FR_CLIENT_FAV_2.png`
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CLIENT_FAV/FR_CLIENT_FAV_3.png`
  }]
};
